var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Set",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#FFB300;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#90CAF9;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#FF7043;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#9CCC65;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#37474F;}\n\t.st7{fill:#37474F;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#37474F;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Billboard_Man"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16,
    y1: 55.6,
    x2: 11,
    y2: 55.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9,
    y1: 55.6,
    x2: 8,
    y2: 55.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 28.6,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.2,25.1l0.4-0.4c-1.1-1.3-2.8-2.2-4.6-2.2c-3.3,0-6,2.7-6,6h0.6C30.1,28.6,33.5,27.3,36.2,25.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,32.5l-1.6,3.2c-0.4,0.8-1.3,1.4-2.2,1.4H38l-3-1.5L32,39l-3-3.5l-3,1.5h-2.2c-0.9,0-1.8-0.5-2.2-1.4 L20,32.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.5,32.5l2.9,5.8c0.8,1.7,2.6,2.8,4.5,2.8H26v11.5h12v-1.4V41.1h3.1c1.9,0,3.6-1.1,4.5-2.8l2.9-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,34.6c-1.1,0-2.1-0.3-3-0.8l0,1.8l3,3.5l3-3.5l0-1.8C34.1,34.3,33.1,34.6,32,34.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "33.5,46.5 32,48.5 30.5,46.5 31,37.5 33,37.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "38,63.5 38,52.6 26,52.6 26,63.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 32,
    y1: 57.6,
    x2: 32,
    y2: 63.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 48,
    y1: 47.6,
    x2: 53,
    y2: 47.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 55,
    y1: 47.6,
    x2: 56,
    y2: 47.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.8,30.5h13.7c1.4,0,2.5-1.1,2.5-2.5V3c0-1.4-1.1-2.5-2.5-2.5h-43C9.1,0.5,8,1.6,8,3v25 c0,1.4,1.1,2.5,2.5,2.5h13.7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9.5,
    className: "st2",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 12,
    className: "st0",
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 17,
    className: "st0",
    width: 20,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 19,
    cy: 15.5,
    r: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/G.ebca234e93b758fa144f4482f02a1d2c.svg";
export { ForwardRef as ReactComponent };